import React from 'react'
import './AppDownloadGate.css'
import downloadQr from '../../../images/download_qr.PNG'

const AppDownloadGate = () => {
	const appleUrl =
		'https://apps.apple.com/us/app/shirey-tournament-tracker/id6752502941'

	const googleUrl =
		'https://play.google.com/store/apps/details?id=app.web.shireytournamenttracker.app132474&hl=en_US'

	return (
		<div className='appDownloadGate'>
			<div className='appDownloadGate__card'>
				<h1>Download the App</h1>

				<p>
					Player Pages are available exclusively in the Shirey Tournament
					Tracker app.
				</p>
				<p>$1.99/month. Cancel anytime.</p>
				{/* MOBILE */}
				<div className='appDownloadGate__buttons'>
					<a href={appleUrl} className='appDownloadGate__button'>
						Download on the App Store
					</a>

					<a href={googleUrl} className='appDownloadGate__button'>
						Get it on Google Play
					</a>
				</div>

				{/* DESKTOP */}
				<div className='appDownloadGate__qrSection'>
					<p className='appDownloadGate__qrInstructions'>
						Scan with your phone to download the app.
					</p>

					<div className='appDownloadGate__qrCodes'>
						<div className='appDownloadGate__qrItem'>
							<div className='appDownloadGate__qrBox'>
								<img
									src={downloadQr}
									alt='Download the Shirey Tournament Tracker app'
									className='appDownloadGate__qrImage'
								/>
							</div>

							<strong>iPhone or Android</strong>
							<span>Scan to download the app</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AppDownloadGate
